import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=951bac16"
import script from "./Items.vue?vue&type=script&lang=js"
export * from "./Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Slash: require('/vercel/path0/components/common/Slash.vue').default,Button: require('/vercel/path0/components/common/Button.vue').default,Label: require('/vercel/path0/components/common/Label.vue').default,Info: require('/vercel/path0/components/common/Info.vue').default,InputGroup: require('/vercel/path0/components/common/InputGroup.vue').default,Button: require('/vercel/path0/components/common/Button.vue').default,Modal: require('/vercel/path0/components/common/Modal.vue').default,Card: require('/vercel/path0/components/common/Card.vue').default})
